import { FileModel } from '@/types';
import { DeleteTwoTone } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { FC } from 'react';

type Props = {
  item: FileModel;
  onDeleteItem: (item: FileModel) => void;
};

const DeleteFileBtn: FC<Props> = (props: Props) => {
  const { onDeleteItem, item } = props;
  return (
    <div className="image__delete">
      <Popconfirm
        title={`Are you sure to delete ${item.name}?`}
        placement="left"
        onConfirm={() => onDeleteItem(item)}
      >
        <Button icon={<DeleteTwoTone twoToneColor="#ff4d4f" />} />
      </Popconfirm>
    </div>
  );
};

export default DeleteFileBtn;
